import React, {useCallback} from "react";
import {Link, Text} from "@fluentui/react";
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";

import type {SignalRMessage} from "../../../services/signalR/models/Messages";
import {removeFromLocalStorage} from "../../../utils/ManageLocalStorage";
import PathConstants from "../../../routes/pathConstants";

const useCalculationCompleteHandler = (): ((
  message: SignalRMessage,
) => void) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userIsOnCalculationsPage = location.pathname
    .split("/")
    .some(s => s === PathConstants.Calculations);
  const execute = useCallback((message: SignalRMessage): void => {

    if(message.data?.constructionId && message.data?.calculationId){
      removeFromLocalStorage(`${message.data.constructionId}.inProgress`);
      const url = `${PathConstants.Constructions}/${message.data.constructionId}/${PathConstants.Calculations}/${message.data.calculationId}`;

      toast(
        <>
          {userIsOnCalculationsPage && (
            <Text>
              Calculation completed. Your data was automatically refreshed.
            </Text>
          )}
          {!userIsOnCalculationsPage && (
            <>
              {" "}
              <Text>
                Click{" "}
                <Link
                  onClick={() => {
                    if (url === location.pathname) {
                      void navigate(0);
                    } else {
                      void navigate(url);
                    }
                  }}>
                  here
                </Link>{" "}
                to navigate to calculation.
              </Text>
            </>
          )}
        </>,
        {toastId: message.data.calculationId},
      );
    }
  }, [location.pathname, navigate, userIsOnCalculationsPage]);
  return execute;
};

export default useCalculationCompleteHandler;
